<script setup lang="ts">
const props = defineProps<{
  text?: string;
}>();
</script>

<template>
  <div :class="$style.separator">
    {{ props.text }}
  </div>
</template>

<style module>
.separator {
  text-align: center;
  color: var(--app-color-black-secondary);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:not(:empty) {
    gap: 20px;
  }

  &::before,
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: var(--app-color-black-primary);
    opacity: 10%;
  }
}
</style>
